/** @format */

import {AnalyticGoalFromQuery} from 'pages/Home/DigitalCast/models/api';

import {CrCustomGoals, Widget} from './model';

export const getComputedCrLabel = <T extends Record<string, unknown>>(
  data: Widget<T>,
  customData: CrCustomGoals,
  analyticGoals: ReadonlyArray<AnalyticGoalFromQuery>,
) => {
  const isCr = data.label === 'CR' || String(data.label).startsWith('CR');
  const aId = customData?.aGoalId;
  const bId = customData?.bGoalId;

  if (!isCr || !aId || !bId || !analyticGoals?.length) return undefined;

  const mapBasic = (id: string | number) => {
    if (id === 'clicks') return 'Клики';
    if (id === 'shows' || id === 'impressions') return 'Показы';
    return undefined;
  };

  const aName = mapBasic(aId) || analyticGoals.find(g => g.id === aId)?.name;
  const bName = mapBasic(bId) || analyticGoals.find(g => g.id === bId)?.name;

  if (!aName || !bName) return undefined;

  return `CR ${aName}/${bName}, %`;
};
